<template>
     <LoginAndSignUp v-if="showLoginModal || showSignupModal" :showUltimeSignUpModal="false" :defaultShowLoginModal="showLoginModal" :defaultShowSignupModal="showSignupModal" @exit="closeModal"/>

     <div class="lp-app">
      <!-- Header Section -->
      <header class="lp-header">
        <div class="lp-header-container">
          <div class="lp-logo flex">
            <img alt="AnimalTheraProp Logo" src="../../assets/logo.png" style="width: 80px;" />
            <h1 style="margin-left: 0.75rem">AnimaTheraPro</h1>
          </div>
          <nav class="lp-nav-menu">
            <ul class="lp-nav-list">
              <li><a href="#questions" class="lp-header-link">Questions ?</a></li>
              <li><a href="#features" class="lp-header-link">Fonctionnalités</a></li>
              <li><a href="#pricing" class="lp-header-link">Tarifs</a></li>
              <!--li><a href="#testimonials" class="header-link">Testimonials</a></li-->
              <!--li><a href="#blog" class="header-link">Blog</a></li-->
            </ul>
          </nav>
          <div class="lp-header-buttons">
            <button class="lp-btn-login lp-btn-connection" @click="showProLoginModal = true">Connexion</button>
            <button class="lp-btn-primary" @click="showSignupModal = true">Essai gratuit</button>
          </div>
          <button class="lp-menu-toggle" @click="toggleMobileMenu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <div class="lp-mobile-menu" :class="{ active: lpMobileMenuOpen }">
          <div class="lp-mobile-nav-list">
            <button class="lp-btn-login-mobile" @click="showProLoginModal = true">Connexion</button>
            <button class="lp-btn-primary-mobile" @click="showSignupModal = true">Essai gratuit</button>
          </div>
        </div>
      </header>
  
      <!-- Hero Section -->
      <section class="lp-hero">
        <div class="lp-hero-container">
          <div class="lp-hero-content">
            <h1 class="lp-hero-title lp-font-color-white" v-motion-slide-visible-once-bottom>Libérez votre potentiel thérapeutique</h1>
            <p class="lp-hero-subtitle lp-font-color-white" v-motion-slide-visible-once-bottom>
              Solution de gestion conçue pour les professionnels de la zoothérapie.<br/>Gagner du temps sur vos tâches administratives.
            </p>
            <div class="lp-hero-cta" v-motion-slide-visible-once-bottom>
              <button class="lp-btn-primary lp-btn-large" @click="showSignupModal = true">Essayer gratuitement pendant 14 jours</button>
            </div>
          </div>
        </div>
        <div>
  
          <svg id="wave" style="transform:rotate(0deg); transition: 0.3s" viewBox="0 0 1440 270" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <defs id="defs1" />
              <g id="layer1" transform="matrix(3.7795276,0,0,3.7795276,427.01908,-205.60174)">
                  <path id="rect2" style="display:inline;fill:#004547;fill-opacity:1;stroke:none;stroke-width:0.499999;stroke-linecap:round;stroke-miterlimit:0;stroke-opacity:1"
          d="m -112.05744,54.398792 c 0,0 70.393867,31.381141 150.241207,35.568439 50.369598,2.641444 123.837013,-27.786936 202.017843,-25.129548 52.74028,1.792657 119.62073,20.525232 119.62104,21.037492 l 0.0462,77.442655 c 3.1e-4,0.51226 -0.4124,0.92466 -0.92466,0.92466 h -471.00166 c -0.51226,0 -0.92466,-0.4124 -0.92466,-0.92466 V 55.32345 c 0,-0.51226 0.4124,-0.924658 0.92466,-0.924658 z"
          inkscape:label="back" /><path
          id="path3"
          style="display:inline;fill:#457b7b;fill-opacity:1;stroke:none;stroke-width:0.499999;stroke-linecap:round;stroke-miterlimit:0;stroke-opacity:1"
          d="m -112.05744,54.398792 c 0,0 79.285977,36.611794 159.133317,40.799092 50.369598,2.641444 122.925473,-34.851437 200.971713,-29.551572 61.80192,4.196766 111.58868,15.46318 111.59013,15.975438 l 0.23113,81.69608 c 10e-4,0.51226 -0.4124,0.92466 -0.92466,0.92466 h -471.00166 c -0.51226,0 -0.92466,-0.4124 -0.92466,-0.92466 V 55.32345 c 0,-0.51226 0.4124,-0.924658 0.92466,-0.924658 z"
          inkscape:label="middle" /><path
          id="path2"
          style="display:inline;fill:#e7fbf5;fill-opacity:1;stroke-width:0.499999;stroke-linecap:round;stroke-miterlimit:0"
          d="m -112.05744,54.398792 c 0,0 73.009193,39.750186 152.856533,43.937484 50.369598,2.641444 128.021537,-35.10985 206.202367,-32.452462 52.74028,1.792657 112.86742,20.311293 112.86742,20.823553 v 76.610463 c 0,0.51226 -0.4124,0.92466 -0.92466,0.92466 h -471.00166 c -0.51226,0 -0.92466,-0.4124 -0.92466,-0.92466 V 55.32345 c 0,-0.51226 0.4124,-0.924658 0.92466,-0.924658 z"
          inkscape:label="front" /></g></svg>
  
          <div class="lp-features-grid">
            <div class="lp-feature-card" v-for="(feature, index) in features" :key="index">
              <div class="lp-feature-icon" :class="`bg-${feature.color}`">
                <img :alt="feature.title" :src="feature.img" />
              </div>
              <div>
                <h3 class="lp-feature-title">{{ feature.title }}</h3>
                <p class="lp-feature-description">{{ feature.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
  
  
      <section id="questions" class="lp-win-win">
        <div class="lp-section-container">
          <div class="lp-section-header" v-motion-slide-visible-once-bottom>
            <h2 class="lp-section-title">Ce que les thérapeutes y gagnent</h2>
          </div>
          <div class="lp-win-win-goals">
            <div 
              v-for="(item, index) in winWinGoals" 
              :key="index" 
              class="lp-win-win-goals-section" 
              :class="{ 'even': index % 2 !== 0 }"
          >
              <div class="lp-win-win-goals-content">
                  <h2 class="lp-win-win-goals-content-title">{{ item.title }}</h2>
                  <p class="lp-win-win-goals-content-text" v-html="item.paragraph"></p>
              </div>
              <div class="lp-image-container">
                  <img :src="item.img || '/api/placeholder/600/400'" :alt="item.title" class="lp-image-placeholder">
              </div>
          </div>
          </div>
        </div>
      </section>
  
      <!-- Features Section -->
      <!---section id="features" class="lp-features">
        <div class="lp-section-container">
          <div class="lp-section-header lp-feature-section-header" v-motion-slide-visible-once-bottom>
            <h2 class="lp-section-title lp-font-color-white">Un outil tout-en-un pour les tâches administratives</h2>
            <p class="lp-section-subtitle lp-feature-section-subtitle lp-font-color-white">Vos animaux et vos patients attendent!<br/>Chaque minute passée sur l'administratif est une minute que vous ne consacrez pas à votre passion : soigner par le lien animal-humain.</p>
          </div>
          
          <div class="lp-features-grid">
            <div class="lp-feature-card" v-for="(feature, index) in features" :key="index" v-motion-slide-visible-once-bottom>
              <div>
                <h3 class="lp-feature-title">{{ feature.title }}</h3>
                <p class="lp-feature-description">{{ feature.description }}</p>
              </div>
              <div class="lp-feature-icon" :class="`bg-${feature.color}`">
                <img :alt="feature.title" :src="feature.img" />
              </div>
            </div>
          </div>
        </div>
      </section-->
  
      <!-- Integration Section -->
      <!--section  class="integrations">
          <div class="section-container">
            <div class="section-header" v-motion-slide-visible-once-bottom>
              <h2 class="section-title">Solution tout-en-un pour les professionnels de la médiation animale</h2>
              <p class="section-subtitle">Conçue en relation avec des théréapeutes en médiation animale, ZoothéraPro répond aux défis uniques de votre profession. 
                Notre mission est simple : vous redonner du temps pour votre véritable expertise - la thérapie par l'animal.</p>
            </div>
          </div>
  
          <button>Voir la démo</button>
      </section-->
  
      <!-- Testimonials Section -->
      <!-- section id="testimonials" class="testimonials">
        <div class="section-container">
          <div class="section-header" v-motion-slide-visible-once-bottom>
            <h2 class="section-title">Loved by teams worldwide</h2>
            <p class="section-subtitle">See why thousands of teams choose MyDesk to organize their work.</p>
          </div>
          
          <div class="testimonial-slider">
            <div class="testimonial-wrapper" ref="testimonialWrapper">
              <div 
                v-for="(testimonial, index) in testimonials" 
                :key="index" 
                class="testimonial-card"
                v-motion-slide-visible-once-bottom
              >
                <div class="testimonial-content">
                  <p class="testimonial-text">{{ testimonial.text }}</p>
                </div>
                <div class="testimonial-author">
                  <div class="author-avatar">
                    <img :alt="testimonial.name" src="/api/placeholder/40/40" />
                  </div>
                  <div class="author-info">
                    <p class="author-name">{{ testimonial.name }}</p>
                    <p class="author-role">{{ testimonial.role }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="slider-controls">
              <button class="control-prev" @click="prevTestimonial">←</button>
              <button class="control-next" @click="nextTestimonial">→</button>
            </div>
          </div>
        </div>
      </section-->
  
      <!-- Pricing Section -->
      <section id="pricing" class="lp-pricing">
        <div class="lp-section-container">
          <div class="lp-section-header" v-motion-slide-visible-once-bottom>
            <h2 class="lp-section-title">Une offre simple et transparente</h2>
            <p class="lp-section-subtitle">Choisissez le plan qui correspond le mieux à votre équipe.</p>
          </div>
                  
          <div class="lp-pricing-grid">
            <div 
              v-for="(plan, index) in pricingPlans" 
              :key="index" 
              class="lp-pricing-card"
              :class="{ 'lp-pricing-card-featured': plan.featured }"
              v-motion-slide-visible-once-bottom
            >
              <div class="lp-pricing-header">
                <h3 class="lp-pricing-title">{{ plan.title }}</h3>
                <p class="lp-pricing-description">{{ plan.description }}</p>
              </div>
              <div v-if="plan.monthlyPrice" class="lp-pricing-price">
                <span class="lp-currency">€</span>
                <span class="lp-amount">{{ plan.monthlyPrice }}</span>
                <span class="lp-period">/mois</span>
              </div>
              <div v-if="plan.additionalPrice" class="lp-pricing-subprice">
                  <p>Plus <span class="lp-amount">{{ plan.additionalPrice }}</span>/personne</p>
              </div>
              <ul class="lp-pricing-features">
                <li v-for="(feature, featureIndex) in plan.features" :key="featureIndex">
                  {{ feature }}
                </li>
              </ul>
              <button 
                class="lp-pricing-button" 
                :class="{ 'lp-btn-primary': plan.featured, 'lp-btn-outline': !plan.featured }"
                @click="showSignupModal = true"
              >
                {{ plan.buttonText }}
              </button>
            </div>
          </div>
        </div>
      </section>
  
      <div class="lp-wave-prices-container">
     
      <svg id="wave" style="transform:rotate(0deg); transition: 0.3s" viewBox="0 0 1440 270" version="1.1" xmlns="http://www.w3.org/2000/svg"><defs
       id="defs1" /><g
       id="layer1"
       transform="matrix(3.7795276,0,0,3.7795276,427.01908,-205.60174)"><path
         id="rect2"
         style="display:inline;fill:#e7fbf5;fill-opacity:1;stroke:none;stroke-width:0.499999;stroke-linecap:round;stroke-miterlimit:0;stroke-opacity:1"
         d="m -112.05744,54.398792 c 0,0 70.393867,31.381141 150.241207,35.568439 50.369598,2.641444 123.837013,-27.786936 202.017843,-25.129548 52.74028,1.792657 119.62073,20.525232 119.62104,21.037492 l 0.0462,77.442655 c 3.1e-4,0.51226 -0.4124,0.92466 -0.92466,0.92466 h -471.00166 c -0.51226,0 -0.92466,-0.4124 -0.92466,-0.92466 V 55.32345 c 0,-0.51226 0.4124,-0.924658 0.92466,-0.924658 z"
         sodipodi:nodetypes="sssssssssss"
         inkscape:label="backback" /><path
         id="path3"
         style="display:inline;fill:#8fc3bd;fill-opacity:1;stroke:none;stroke-width:0.499999;stroke-linecap:round;stroke-miterlimit:0;stroke-opacity:1"
         d="m -112.05744,54.398792 c 0,0 79.285977,36.611794 159.133317,40.799092 50.369598,2.641444 122.925473,-34.851437 200.971713,-29.551572 61.80192,4.196766 111.58868,15.46318 111.59013,15.975438 l 0.23113,81.69608 c 10e-4,0.51226 -0.4124,0.92466 -0.92466,0.92466 h -471.00166 c -0.51226,0 -0.92466,-0.4124 -0.92466,-0.92466 V 55.32345 c 0,-0.51226 0.4124,-0.924658 0.92466,-0.924658 z"
         sodipodi:nodetypes="sssssssssss"
         inkscape:label="middle" /><path
         id="path2"
         style="display:inline;fill:#004547;fill-opacity:1;stroke-width:0.499999;stroke-linecap:round;stroke-miterlimit:0"
         d="m -112.05744,54.398792 c 0,0 73.009193,39.750186 152.856533,43.937484 50.369598,2.641444 128.021537,-35.10985 206.202367,-32.452462 52.74028,1.792657 112.86742,20.311293 112.86742,20.823553 v 76.610463 c 0,0.51226 -0.4124,0.92466 -0.92466,0.92466 h -471.00166 c -0.51226,0 -0.92466,-0.4124 -0.92466,-0.92466 V 55.32345 c 0,-0.51226 0.4124,-0.924658 0.92466,-0.924658 z"
         sodipodi:nodetypes="ssssssssss"
         inkscape:label="front" /></g></svg>
        </div>
      <!-- CTA Section -->
      <section class="lp-cta">
        
        <div class="lp-cta-container" v-motion-slide-visible-once-bottom>
          <h2 class="lp-section-title lp-cta-title">Rejoignez les thérapeutes qui ont déjà transformé leur pratique</h2>
          <p class="lp-section-subtitle lp-cta-subtitle" style="margin-bottom: 1rem">Chaque jour que vous passez avec vos systèmes actuels vous coûte du temps, de l'énergie et de l'argent.<br/> Vos patients et vos animaux méritent que vous consacriez votre temps à ce qui compte vraiment <br/> <strong>la thérapie</strong></p>
          <div class="lp-cta-buttons">
            <button class="lp-btn-primary lp-btn-large lp-font-color-white" @click="showSignupModal = true">Commencer mon essai gratuit</button>
            <button class="lp-btn-secondary" @click="goToCalendly">
              Réserver une démo personnalisée</button>
          </div>
        </div>
      </section>
  
  
      <!-- Footer -->
      <footer class="lp-footer">
        <div class="lp-footer-container">
          <div class="lp-footer-company">
            <img alt="AnimaTheraPro Logo" src="../../assets/logo.png" style="width: 80px;" class="lp-footer-logo" />
            <div class="lp-social-links">
              <a href="#" class="lp-social-link">LinkedIn</a>
              <a href="#" class="lp-social-link">Facebook</a>
            </div>
          </div>
          
          <div class="lp-footer-links">
            <div class="lp-footer-column">
              <h4 class="lp-footer-heading">Produit</h4>
              <ul>
                <li><a href="#">Fonctionnalités</a></li>
                <li><a href="#">Tarif</a></li>
              </ul>
            </div>
            <div class="lp-footer-column">
              <h4 class="lp-footer-heading">Entreprise</h4>
              <ul>
                <li><a href="#">A propos</a></li>
                <li><a href="mailto:contact@animatherapro.com">Contact</a></li>
              </ul>
            </div>
            <!--div class="footer-column">
              <h4 class="footer-heading">Resources</h4>
              <ul>
                <li><a href="#">Documentation</a></li>
                <li><a href="#">Guides</a></li>
                <li><a href="#">Help Center</a></li>
                <li><a href="#">API</a></li>
              </ul>
            </div-->
            <div class="lp-footer-column">
              <h4 class="lp-footer-heading">Légal</h4>
              <ul>
                <li><a href="/public/cgu">C.G.U</a></li>
                <li><a href="/public/cgu">C.G.V</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="lp-footer-bottom">
          <p class="lp-copyright">© {{ new Date().getFullYear() }} AnimaTheraPro, tous droits réservés.</p>
        </div>
      </footer>
      <LoginAndSignUp v-if="showProLoginModal" :showUltimeSignUpModal="false" :defaultShowLoginModal="showProLoginModal" :defaultShowSignupModal="false" @exit="closeModal"/>
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'LandingPage',
    data() {
      return {
        showProLoginModal: false,
        showSignupModal : false,
        lpMobileMenuOpen: false,
        isAnnual: true,
        currentTestimonialIndex: 0,
        features: [
          {
            title: 'Bien-être animal',
            description: 'Le temps d\'action de vos animaux est limité, comment le gérer ?',
            img: '/images/animalWelfare.png',
            color: 'white'
          },
          {
            title: 'Dossiers patients',
            description: 'Vous perdez du temps dans la gestion de vos patients ?',
            img: '/images/dossierPatient.png',
            color: 'white'
          },
          {
            title: 'Tâches administratives',
            description: 'L\'administratif vous prend trop de temps ?',
            img: '/images/facturation.png',
            color: 'white'
          }
        ],
        winWinGoals: [
          {
            title:'Respecter le bien-être des animaux',
            paragraph:'Un calendrier intelligent qui vous alerte lorsqu\'un animal approche de sa limite d\'heures de travail hebdomadaire. <br/>Une vue synthétique de vos disponibilités et de celles de vos animaux thérapeutiques.<br/>Finis les plannings surchargés et le stress pour vos animaux',
            img: '/images/easter-bunny-49.svg'//img: '/images/animal-welfare.jpg'
          },
          {
            title:'Dossiers patients centralisés',
            paragraph:'Stockez toutes les informations importantes sur vos patients: objectifs thérapeutiques, contre-indications, historique des séances, et suivi des progrès.',
            
            img: '/images/files-and-folder-92.svg'//img: '/images/dossierCentralise.jpg' --www.manypixels.co
          },
          {
            title: 'Facturation automatisée',
            paragraph: 'Créez vos factures professionnelles en 3 clics, simplifiez vous le suivi des paiements.',
            img: '/images/money-1-29.svg'//img: '/images/billing.jpg'
          },
          {
            title: 'Importer mes données existantes ?',
            paragraph: 'Absolument ! Si vous avez un export, nous pouvons discuter de la migration de vos données existantes (clients, planning, animaux)',
            img: '/images/data-analysis-59.svg'//img: '/images/datacenter.jpg'
          },
          {
            title: 'La prise en main, est-ce compliqué ?',
            paragraph: 'ZooTheraPro a été conçu spécifiquement pour être accessible à tous. <br/>Notre interface est intuitive et notre équipe vous propose une formation personnalisée pour vous mettre à l\'aise.<br/>Nos utilisateurs maîtrisent l\'outil en moins d\'1 heure.',
            img: '/images/question.jpg'
          }
  
        ],
        testimonials: [
          {
            text: "MyDesk has transformed how our team collaborates. We've increased productivity by 30% since implementing it across our organization.",
            name: "Sarah Johnson",
            role: "Product Manager at TechCorp"
          },
          {
            text: "The intuitive interface and powerful features have made project management a breeze. Our team adopted it immediately with minimal training.",
            name: "Michael Chang",
            role: "CTO at StartupHub"
          },
          {
            text: "We tried many project management tools, but MyDesk is the only one that perfectly balances simplicity and advanced features.",
            name: "Emily Rodriguez",
            role: "Team Lead at DesignStudio"
          },
          {
            text: "The customer support team is exceptional. Any time we've had questions, they've responded quickly with helpful solutions.",
            name: "David Wilson",
            role: "Operations Manager at GrowthInc"
          }
        ],
        pricingPlans: [
          {
            title: "Standard",
            description: "Le praticien ou la praticienne",
            monthlyPrice: "24.90",
            features: [
              "Gestion des patients",
              "Gestion des animaux",
              "Gestion de la facturation"
            ],
            buttonText: "Essai gratuit",
            featured: false
          },
          {
            title: "Premium",
            description: "Le praticien ou la praticienne + un collaborateur",
            monthlyPrice: "59.90",
            features: [
              "Gestion des patients",
              "Gestion des animaux",
              "Gestion de la facturation",
              "Gestion d'équipe (5 personnes maximum)"
            ],
            buttonText: "Essai gratuit",
            featured: true
          },
          {
            title: "Sur devis",
            description: "",
            features: [
              "Gestion des patients",
              "Gestion des animaux",
              "Gestion de la facturation",
              "+ de 5 personnes"
            ],
            buttonText: "Nous contacter",
            featured: false
          },
        ]
      };
    },
    methods: {
      goToCalendly() {
        window.open('https://calendly.com/vincent-lesquere/meeting', '_blank');
      },
      closeModal() {
        this.showProLoginModal = false;
        this.showSignupModal = false;
      },
      toggleMobileMenu() {
        this.lpMobileMenuOpen = !this.lpMobileMenuOpen;
        const mobileMenu = document.querySelector('.lp-mobile-menu');
        if (this.lpMobileMenuOpen) {
          mobileMenu.classList.add('active');
        } else {
          mobileMenu.classList.remove('active');
        }
      },
      closeMobileMenu() {
        this.lpMobileMenuOpen = false;
        const mobileMenu = document.querySelector('.lp-mobile-menu');
        mobileMenu.classList.remove('active');
      },
      nextTestimonial() {
        if (this.currentTestimonialIndex < this.testimonials.length - 1) {
          this.currentTestimonialIndex++;
          this.scrollToTestimonial();
        }
      },
      prevTestimonial() {
        if (this.currentTestimonialIndex > 0) {
          this.currentTestimonialIndex--;
          this.scrollToTestimonial();
        }
      },
      scrollToTestimonial() {
        const testimonialWrapper = this.$refs.testimonialWrapper;
        if (testimonialWrapper) {
          const testimonialWidth = testimonialWrapper.querySelector('.testimonial-card').offsetWidth;
          const scrollPosition = testimonialWidth * this.currentTestimonialIndex;
          testimonialWrapper.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
        }
      },
      handleScroll() {
        const header = document.querySelector('.lp-header');
        const btnConnection = document.querySelector('.lp-btn-connection');
        const headerLink = document.querySelectorAll('.lp-header-link');
        if (window.scrollY > 50) {
          header.classList.add('lp-header-scrolled');
          header.classList.remove('lp-font-color-white');
          btnConnection.classList.remove('lp-font-color-white');
          headerLink.forEach(link => link.classList.remove('lp-font-color-white'));
        } else {
          header.classList.remove('lp-header-scrolled');
          header.classList.add('lp-font-color-white');
          btnConnection.classList.add('lp-font-color-white');
          headerLink.forEach(link => link.classList.add('lp-font-color-white'));
        }
      }
    },
    mounted() {
      // Add scroll event listener for header behavior
      window.addEventListener('scroll', this.handleScroll);
      const btnConnection = document.querySelector('.lp-btn-connection');
      btnConnection.classList.add('lp-font-color-white');
      const headerLink = document.querySelectorAll('.lp-header-link');
      headerLink.forEach(link => link.classList.add('lp-font-color-white'));
    },
    beforeUnmount() {
      // Clean up event listener when component is unmounted
      window.removeEventListener('scroll', this.handleScroll);
    }
  }
  </script>
  
  <style>
  @font-face {
      font-family: manrope;
      src: url('~@/assets/fonts/Manrope-VariableFont_wght.ttf');
  }
  
  :root {
    --anima-light-color: #e7fbf5; /*(231, 251, 245)*/
    --anima-primary-color: #32a852;
    --anima-secondary-color: #457b7b; /*(69, 123, 123)*/
    --anima-ternary-color: #004547; /*(0, 69, 71)*/
    --anima-accent-color: #14c8b7;
    --anima-dark-color: #111927;
    --anima-bg-color: #ffffff;
    --anima-text-color: #374151;
    --anima-heading-color: #111927;
    --anima-border-color: #e5e7eb;
  
    --anima-font-color--text-highlight:#00b172;
    
    --anima-color-blue: rgba(74, 108, 247, 0.1);
    --anima-color-green: rgba(20, 200, 183, 0.1);
    --anima-color-purple: rgba(128, 90, 213, 0.1);
    --anima-color-orange: rgba(249, 115, 22, 0.1);
    --anima-color-red: rgba(239, 68, 68, 0.1);
    --anima-color-teal: rgba(20, 184, 166, 0.1);
    
    --anima-shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    --anima-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    --anima-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    
    --anima-radius-sm: 0.25rem;
    --anima-radius-md: 0.5rem;
    --anima-radius-lg: 1rem;
    
    --anima-transition: all 0.3s ease;
    
    --anima-container-width: 1200px;
    --anima-container-padding: 2rem;
  }
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: 'Inter', sans-serif;
    color: var(--anima-text-color);
    background-color: var(--anima-bg-color);
    line-height: 1.6;
  
    font-family: 'manrope', sans-serif;
  }
  
  a {
    text-decoration: none;
    color: inherit;
    transition: var(--anima-transition);
  }
  
  ul {
    list-style: none;
  }
  
  button {
    cursor: pointer;
    font-family: inherit;
    border: none;
    background: none;
    transition: var(--anima-transition);
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  .lp-app {
    overflow-x: hidden;
  }
  
  /* Container Styles */
  .lp-section-container,
  .lp-header-container,
  .lp-hero-container,
  .lp-footer-container {
    max-width: var(--anima-container-width);
    margin: 0 auto;
    padding: 0 var(--anima-container-padding);
  }
  
  .lp-font-color-white {
    color: white !important;
  }
  
  .lp-text-highlight {
    color: var(--anima-font-color--text-highlight);
  }
  /* Button Styles */
  .lp-btn-primary {
    background-color: var(--anima-primary-color) !important;
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: var(--anima-radius-md) !important;
    font-weight: 600;
    box-shadow: var(--anima-shadow-md) !important;
  }
  
  .lp-btn-primary:hover {
    background-color: var(--anima-anima-secondary-color) !important;
    transform: translateY(-2px) !important;
  }
  
  .lp-btn-secondary {
    background-color: white  !important;
    color: var(--anima-primary-color) !important;
    padding: 0.75rem 1.5rem !important;
    border-radius: var(--anima-radius-md) !important;
    font-weight: 600 !important;
    border: 1px solid var(--anima-border-color) !important;
  }
  
  .lp-btn-secondary:hover {
    border-color: var(--anima-primary-color) !important;
    transform: translateY(-2px) !important;
  }
  
  .lp-btn-login {
    font-weight: 600 !important;
  }
  
  .lp-btn-login:hover {
    color: var(--anima-primary-color)  !important;
  }
  
  .lp-btn-large {
    padding: 1rem 2rem  !important;
    font-size: 1.1rem !important;
  }
  
  .lp-btn-outline {
    background-color: transparent !important;
    border: 1px solid var(--anima-border-color) !important;
    color: var(--anima-text-color) !important;
  }
  
  .lp-btn-outline:hover {
    border-color: var(--anima-primary-color) !important;
    color: var(--anima-primary-color) !important;
  }
  
  /* Header Styles */
  .lp-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 1.5rem 0;
    background-color: transparent;
    z-index: 1000;
    transition: var(--anima-transition);
  }
  
  .lp-header-scrolled {
    background-color: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    padding: 1rem 0;
    box-shadow: var(--anima-shadow-sm);
  }
  
  .lp-header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .lp-logo {
    font-size: 1.5rem;
    font-weight: 700;
    justify-content: center;
    align-items: center;
    color: white;
  }
  
  .lp-nav-menu {
    display: flex;
  }
  
  .lp-nav-list {
    display: flex;
    gap: 2rem;
  }
  
  .lp-nav-list a {
    font-weight: 500;
  }
  
  .lp-nav-list a:hover {
    color: var(--anima-primary-color);
  }
  
  .lp-header-buttons {
    display: flex;
    align-items: center;
    gap: 1.5rem;
  }
  
  .lp-menu-toggle {
    display: none;
    flex-direction: column;
    gap: 5px;
  }
  
  .lp-menu-toggle span {
    width: 24px;
    height: 2px;
    background-color: var(--anima-dark-color);
    transition: var(--anima-transition);
  }
  
  .lp-mobile-menu {
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 7rem;
    background-color: white;
    padding: 1rem;
    box-shadow: var(--anima-shadow-md);
    transition: var(--anima-transition);
    z-index: 999;
  }
  
  .lp-mobile-menu.active {
    display: block; /* Ensure the menu is visible */
    transform: translateY(0);
  }
  
  .lp-mobile-nav-list {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 1rem;
  }
  
  .lp-mobile-nav-list li {
    border-bottom: 1px solid var(--anima-border-color);
  }
  
  .lp-btn-login-mobile,
  .lp-btn-primary-mobile {
    width: 100%;
    margin-top: 1rem;
    padding: 0.75rem;
    text-align: center;
    border-radius: var(--anima-radius-md);
  }
  
  .lp-btn-login-mobile {
    color: var(--anima-secondary-color);
    border: 2px solid var(--anima-secondary-color);
    background-color: transparent;
  }
  
  .lp-btn-primary-mobile {
    background-color: var(--anima-primary-color);
    color: white;
  }
  
  /* Hero Section */
  .lp-hero {
    padding: 160px 0 0px;
    background-color: var(--anima-ternary-color);
  }

  .lp-hero-container {
    display: flex;
    align-items: center;
    gap: 2rem;
  }
  
  .lp-hero-content {
    flex: 1;
    justify-content: center;
  }
  
  .lp-hero-title {
    font-size: 3.5rem;
    line-height: 1.1;
    color: var(--anima-heading-color);
    margin-bottom: 1.5rem;
    font-weight: 700;
    text-align: center;
  }
  
  .lp-hero-subtitle {
    font-size: 1.25rem;
    color: var(--anima-secondary-color);
    margin-bottom: 2.5rem;
    text-align: center;
  }
  
  .lp-hero-cta {
    display: flex;
    gap: 1rem;
    justify-content: center;
  }
  
  /* Section Header */
  .lp-section-header {
    text-align: center;
    max-width: 800px;
    margin: 0 auto 4rem;
  }
  
  .lp-section-title {
    font-size: 2.5rem;
    color: var(--anima-heading-color);
    margin-bottom: 1rem;
    font-weight: 700;
  }
  
  .lp-section-subtitle {
    font-size: 1.1rem;
    color: var(--anima-secondary-color);
  }
  
  .lp-feature-section-header {
    max-width: 90%;
  }

  .lp-feature-section-subtitle {
    font-size: 1rem;
  }

  /* Features Section */
  .lp-features {
    padding: 100px 0;
    background: var(--anima-ternary-color);
    color: white;
  }
  
  .lp-features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 320px));
    justify-content: center;
    gap: 2rem;
    margin-top: -14rem;
    position: relative;
  }
  
  .lp-feature-card {
    padding: 0.5rem;
    border-radius: var(--anima-radius-md);
    background-color: white;
    transition: var(--anima-transition);
    border: 1px solid var(--anima-border-color);
    display: flex;
  }
  
  .lp-feature-card:hover {
    transform: translateY(-5px);
    box-shadow: var(--anima-shadow-md);
  }
  
  .lp-feature-icon {
    border-radius: var(--anima-radius-sm);
    width: 100px;
  }
  
  
  .lp-bg-blue { background-color: var(--anima-color-blue); }
  .lp-bg-green { background-color: var(--anima-color-green); }
  .lp-bg-purple { background-color: var(--anima-color-purple); }
  .lp-bg-orange { background-color: var(--anima-color-orange); }
  .lp-bg-red { background-color: var(--anima-color-red); }
  .lp-bg-teal { background-color: var(--anima-color-teal); }
  
  .lp-feature-title {
    font-size: 1rem;
    color: var(--anima-heading-color);
    margin-bottom: 0.75rem;
    font-weight: 600;
  }
  
  .lp-feature-description {
    color: var(--anima-secondary-color);
  }
  
  /* Integrations Section */
  .lp-integrations {
    padding: 80px 0;
  }
  
  .lp-integration-logos {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;
    margin-top: 3rem;
  }
  
  .lp-win-win {
    padding: 12rem 0;
    background: linear-gradient(var(--anima-light-color), white);
  
  }
  
  .lp-win-win-goals div {
    padding: 10px 0;
  }
  
  .lp-win-win-goals-section {
      display: flex;
      align-items: center;
      gap: 60px;
  }
          
  .lp-win-win-goals-section.even {
      flex-direction: row-reverse;
  }
  
  .lp-win-win-goals-content, .image-container {
      flex: 1;
  }
  
  .lp-win-win-goals-content {
      padding: 20px;
  }

  .lp-win-win-goals-content-title {
    font-size: 2rem;
  }

  .lp-win-win-goals-content-text {
    font-size: 1rem;
  }

  .lp-image-container {
    width: 260px;
  }

  .lp-logo-item {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
    transition: var(--anima-transition);
  }
  
  .lp-logo-item:hover {
    opacity: 1;
  }
  
  /* Testimonials Section */
  .lp-testimonials {
    padding: 100px 0;
  }
  
  .lp-testimonial-slider {
    position: relative;
    overflow: hidden;
  }
  
  .lp-testimonial-wrapper {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  .lp-testimonial-wrapper::-webkit-scrollbar {
    display: none;
  }
  
  .lp-testimonial-card {
    flex: 0 0 100%;
    min-width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    background-color: white;
    border-radius: var(--anima-radius-md);
    box-shadow: var(--anima-shadow-md);
    scroll-snap-align: center;
  }
  
  .lp-testimonial-text {
    font-size: 1.25rem;
    color: var(--anima-dark-color);
    line-height: 1.7;
    margin-bottom: 2rem;
    font-style: italic;
  }
  
  .lp-testimonial-author {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  
  .lp-author-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
  }
  
  .lp-author-name {
    font-weight: 600;
    color: var(--anima-heading-color);
  }
  
  .lp-author-role {
    color: var(--anima-secondary-color);
    font-size: 0.9rem;
  }
  
  .lp-slider-controls {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-top: 2rem;
  }
  
  .lp-control-prev,
  .lp-control-next {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: white;
    border: 1px solid var(--anima-border-color);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
  }
  
  .lp-control-prev:hover,
  .lp-control-next:hover {
    background-color: var(--anima-primary-color);
    color: white;
    border-color: var(--anima-primary-color);
  }
  
  /* Pricing Section */
  .lp-pricing {
    padding: 100px 0;
    background-color: #e7fbf5;
  }
  
  .lp-pricing-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 3rem;
    gap: 1rem;
    font-weight: 500;
  }
  
  .lp-pricing-toggle span {
    color: var(--anima-secondary-color);
  }
  
  .lp-pricing-toggle span.active {
    color: var(--anima-heading-color);
  }
  
  .lp-discount {
    background-color: rgba(74, 108, 247, 0.1);
    color: var(--anima-primary-color);
    padding: 0.25rem 0.5rem;
    border-radius: var(--anima-radius-sm);
    font-size: 0.8rem;
    margin-left: 0.5rem;
  }
  
  .lp-switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 30px;
  }
  
  .lp-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .lp-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e5e7eb;
    transition: var(--anima-transition);
    border-radius: 34px;
  }
  
  .lp-slider:before {
    position: absolute;
    content: "";
    height: 22px;
    width: 22px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: var(--anima-transition);
    border-radius: 50%;
  }
  
  input:checked + .slider {
    background-color: var(--anima-primary-color);
  }
  
  input:checked + .slider:before {
    transform: translateX(30px);
  }
  
  .lp-pricing-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .lp-pricing-card {
    background-color: white;
    border-radius: var(--anima-radius-md);
    padding: 2.5rem 2rem;
    transition: var(--anima-transition);
    border: 1px solid var(--anima-border-color);
    display: flex;
    flex-direction: column;
  }
  
  .lp-pricing-card-featured {
    transform: scale(1.05);
    box-shadow: var(--anima-shadow-lg);
    border-color: var(--anima-primary-color);
    border-width: 2px;
    position: relative;
    z-index: 1;
  }
  
  .lp-pricing-card:hover {
    transform: translateY(-10px);
    box-shadow: var(--anima-shadow-md);
  }
  
  .lp-pricing-card-featured:hover {
    transform: scale(1.05) translateY(-10px);
  }
  
  .lp-pricing-header {
    margin-bottom: 2rem;
  }
  
  .lp-pricing-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--anima-heading-color);
    margin-bottom: 0.5rem;
  }
  
  .lp-pricing-description {
    color: var(--anima-secondary-color);
  }
  
  .lp-pricing-price {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--anima-heading-color);
    margin-bottom: 2rem;
    display: flex;
    align-items: baseline;
  }
  
  .lp-pricing-subprice {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--anima-heading-color);
    margin-bottom: 2rem;
    display: flex;
    align-items: baseline;
  }
  
  .lp-currency {
    font-size: 1.5rem;
    margin-right: 0.25rem;
  }
  
  .lp-period {
    font-size: 1rem;
    font-weight: 400;
    color: var(--anima-secondary-color);
    margin-left: 0.5rem;
  }
  
  .lp-pricing-features {
    margin-bottom: 2rem;
    flex-grow: 1;
  }
  
  .lp-pricing-features li {
    padding: 0.75rem 0;
    color: var(--anima-text-color);
    border-bottom: 1px solid var(--anima-border-color);
    display: flex;
    align-items: center;
  }
  
  .lp-pricing-features li:last-child {
    border-bottom: none;
  }
  
  .lp-pricing-button {
    width: 100%;
    padding: 1rem;
    border-radius: var(--anima-radius-md);
    font-weight: 600;
    text-align: center;
  }
  
  /*
    --anima-primary-color: #8fc3bd; /*(143, 195, 189)
    --anima-secondary-color: #457b7b; /*(69, 123, 123)
    --anima-ternary-color: #004547; /*(0, 69, 71)
  
  */
  /* CTA Section */
  .lp-cta {
    padding: 100px 0;
    background: linear-gradient(var(--anima-ternary-color),var(--anima-secondary-color));
    color: white;
  }
  
  
  .lp-cta-container {
    max-width: 90%;
    margin: 0 auto;
    padding: 0 var(--anima-container-padding);
    text-align: center;
  }
  
  .lp-cta-title {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    color: white !important;
  }
  
  .lp-cta-subtitle {
    font-size: 1.25rem;
    margin-bottom: 2.5rem;
    opacity: 0.9;
    color: white !important;
  }
  
  .lp-cta-buttons {
    display: flex;
    gap: 1rem;
    justify-content: center;
  }
  
  .lp-cta .lp-btn-primary {
    background-color: white;
    color: var(--anima-primary-color);
  }
  
  .lp-cta .lp-btn-primary:hover {
    background-color: var(--anima-light-color);
  }
  
  .lp-cta .lp-btn-secondary {
    background-color: transparent;
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.3);
  }
  
  .lp-cta .lp-btn-secondary:hover {
    border-color: white;
  }
  
  /* Footer */
  .lp-footer {
    background-color: var(--secondary-color);
    color: white;
    padding: 80px 0 0;
  }
  
  .lp-footer-column {
    display: block !important;
  }

  .lp-footer-container {
    display: grid !important;
    grid-template-columns: 2fr 3fr;
    gap: 4rem;
  }
  
  .lp-footer-company {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    gap: 1.5rem;
  }
  
  .lp-footer-logo {
    max-width: 150px;
  }
  
  .lp-footer-description {
    color: rgba(255, 255, 255, 0.7);
    max-width: 300px;
  }
  
  .lp-social-links {
    display: flex;
    gap: 1rem;
  }
  
  .lp-social-link {
    opacity: 0.7;
    transition: var(--anima-transition);
  }
  
  .lp-social-link:hover {
    opacity: 1;
    color: var(--anima-primary-color);
  }
  
  .lp-footer-links {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
  }
  
  .lp-footer-heading {
    font-size: 1.1rem;
    margin-bottom: 1.5rem;
    font-weight: 600;
  }
  
  .lp-footer-column ul {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .lp-footer-column a {
    color: rgba(255, 255, 255, 0.7);
    transition: var(--anima-transition);
  }
  
  .lp-footer-column a:hover {
    color: white;
  }
  
  .lp-footer-bottom {
    margin-top: 4rem;
    padding: 1.5rem 0;
    text-align: center;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .lp-copyright {
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.9rem;
  }
  
  .lp-wave-prices-container {
    background-color: var(--anima-light-color);
    margin: -1rem;
  }
  
  /* Responsive Styles */
  @media (max-width: 1024px) {
    .lp-hero-title {
      font-size: 2.8rem;
    }
    
    .lp-section-title {
      font-size: 2rem;
    }
    
    .lp-hero-container {
      flex-direction: column;
    }
    
    .lp-footer-container {
      grid-template-columns: 1fr;
      gap: 3rem;
    }
    
    .lp-footer-links {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  @media (max-width: 768px) {
    .lp-features-grid {
      margin-top: 0;
    }

    .lp-nav-menu, .lp-header-buttons {
      display: none;
    }
    
    .lp-menu-toggle {
      display: flex;
    }
    
    .lp-mobile-menu {
      display: block;
    }
    
    .lp-hero {
      padding: 120px 0 60px;
    }
    
    .lp-hero-title {
      font-size: 2.3rem;
    }
    
    .lp-section-title {
      font-size: 1.8rem;
    }
    
    .lp-features-grid {
      grid-template-columns: 1fr;
    }
    
    .lp-pricing-grid {
      grid-template-columns: 1fr;
    }
  
    .lp-pricing-card-featured {
      transform: scale(1);
    }
  
    .lp-pricing-card-featured:hover {
      transform: translateY(-10px);
    }
    
    .lp-hero-cta, .lp-cta-buttons {
      flex-direction: column;
    }
    
    .lp-testimonial-card {
      padding: 1.5rem;
    }
  
  }
  
  @media (max-width: 480px) {
    .lp-hero-title {
      font-size: 2rem;
    }
    
    .lp-hero-subtitle {
      font-size: 1.1rem;
    }
    
    .lp-section-container,
    .lp-header-container,
    .lp-hero-container,
    .lp-cta-container,
    .lp-footer-container {
      padding: 0 1rem;
    }
    
    .lp-footer-links {
      grid-template-columns: 1fr;
    }
  }
  
  /* Animation Classes */
  .lp-fade-in {
    animation: fadeIn 0.8s ease forwards;
  }
  
  .lp-slide-up {
    animation: slideUp 0.8s ease forwards;
  }
  
  .lp-slide-right {
    animation: slideRight 0.8s ease forwards;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes slideRight {
    from {
      opacity: 0;
      transform: translateX(-50px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  </style>
  